<template>
    <div class="img_box" @click.stop v-if="image.length !== 0 || video.length !== 0">
        <!-- 浏览器打开的支持查看大图 -->
        <div class="thumbnail">
            <div
                ref="imgItem"
                :isrc="item.video_image"
                v-for="(item,i) in video"
                class="img-item"
                :class="{'img-item-one':image.length === 0}"
                :key="randomStr + i"
            >
                <div @click="clickPlay(item.video_url)">
                    <div class="vedio_img" v-if="item.video_image">
                        <span class="vedio_image">
                            <img class="vedio_image_img" :src="item.video_image" alt />
                        </span>
                    </div>
                    <div class="paly_video">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconbofangsanjiaoxing" />
                        </svg>
                    </div>
                    <div class="video_len">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconshipinshijian" />
                        </svg>
                        <span>{{item.video_len}}s</span>
                    </div>
                </div>
            </div>
            <div
                ref="imgItem"
                :isrc="item"
                class="img-item"
                v-for="(item,index) in emImg"
                :class="{
                    'img-item-one':image.length==1 && (!video || video.length==0),
                    'img-item-is_hide': (((video.length !== 0 && video.length > 0) && index > 1) || ((!video || video.length==0) && index > 2) )&& page != 'detail',
                }"
                :key="'index'+index"
            >
                <img
                    v-if="kind!='preview'"
                    class="live_img"
                    @load="$previewRefresh"
                    :preview="randomStr"
                    :src="item"
                    alt="图片"
                />
                <img
                    v-else
                    class="live_img"
                    :src="item"
                    alt="图片"
                />
                <span class="image_c" v-if="(((video.length !== 0 && video.length > 0) && index == 1 && emImg.length > 2) || ((!video || video.length==0) && index == 2 && emImg.length > 3) ) && page != 'detail'" @click.stop.prevent="goDetail">{{emImg.length}}图</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "imageViewpoint",
    props: {
        image: Array,
        video: Array,
        page: String, // 页面来源
        kind:String,//preview的不能点击
    },
    data() {
        return {
            emImg: [],
            randomStr: Math.random().toString(36).slice(-4),
        };
    },

    created() {},
    updated() {
        this.setStyle();
    },
    mounted() {
        this.emImg = this.image;
        this.setStyle();
    },
    methods: {
        goDetail() {
            if(this.kind == 'preview') return false;
            this.$parent.handleClickToDetail()
        },
        clickPlay(src) {
            if(this.kind == 'preview') return false;
            this.$videoplay.open(src);
        },
        setStyle() {
            // 图片样式

            if (this.$refs.imgItem && this.$refs.imgItem.length > 0) {
                this.$refs.imgItem.forEach((element) => {
                    let eWidth = element.offsetWidth;
                    let live_img = element.querySelectorAll(
                        "img.live_img,img.vedio_image_img"
                    )[0];
                    let isOneImg = element.classList.contains("img-item-one"); //是否是单独的
                    let isrc = element.getAttribute("isrc");
                    element.style.height = eWidth + "px";
                    let _img = new Image();
                    _img.onload = function () {
                        let maxHeight = (eWidth * 5) / 3;
                        let maxWidth = (eWidth * 5) / 3;
                        let oneMaxHeight = (maxHeight * 3) / 4;
                        let tempWidth = 0;
                        let tempHeight = 0;
                        if (!isOneImg) {
                            if (_img.width / _img.height >= 1) {
                                //横向图
                                live_img.classList.add("widthlong");
                            } else {
                                //竖向图
                                live_img.classList.add("heightlong");
                            }
                        } else {
                            if (_img.width / _img.height >= 1) {
                                //横向图
                                var o_height = Math.ceil(
                                    _img.height / (_img.width / maxWidth)
                                );
                                o_height =
                                    o_height > oneMaxHeight
                                        ? o_height
                                        : oneMaxHeight;
                                tempWidth = maxWidth;
                                tempHeight = o_height;
                                live_img.classList.add("widthlong");
                            } else {
                                //竖向图
                                var o_width = Math.ceil(
                                    _img.width / (_img.height / maxHeight)
                                );
                                o_width =
                                    o_width > oneMaxHeight
                                        ? o_width
                                        : oneMaxHeight;
                                tempHeight = maxHeight;
                                tempWidth = o_width;
                                live_img.classList.add("heightlong");
                            }
                            element.style.cssText = `width:${tempWidth}px;height:${tempHeight}px;`;
                        }
                    };
                    _img.src = isrc;
                });
            }
        },
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" >
.img_box {
    padding-top: 10px;
}
//图片样式
.thumbnail {
    display: flex;
    flex-wrap: wrap;
    padding: 0 0 0 0;

    .img-item {
        position: relative;
        overflow: hidden;
        width: 33.33%;
        padding: 0px;
        border: 3px solid #ffffff;
        box-sizing: border-box;
        margin: 0;
        &:first-child {
            border-left: none;
        }

        &.img-item-is_hide {
            width: 0;
            height: 0;
            overflow: hidden;
            visibility: hidden;
        }
        .heightlong {
            position: absolute;
            width: 100%;
            height: auto;
            top: 50%;
            transform: translateY(-50%);
        }
        .widthlong {
            position: absolute;
            height: 100%;
            width: auto;
            left: 50%;
            transform: translateX(-50%);
        }

        .paly_video {
            position: absolute;
            left: 50%;
            top: 50%;
            margin-top: -15px;
            margin-left: -15px;
            display: flex;
            width: 30px;
            height: 30px;
            overflow: hidden;
            border-radius: 50%;
            border: 2px solid #ffffff;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.15);
            > .icon {
                font-size: 13px;
                margin-left: 3px;
            }
        }
        .video_len {
            position: absolute;
            display: flex;
            align-items: center;
            height: 19px;
            padding: 0 5px;
            right: 0;
            bottom: 0;
            border-radius: 5px 0 0 0;
            background: rgba(0, 0, 0, 0.55);
            font-size: 11px;
            color: #fefffe;
            > .icon {
                font-size: 12px;
                margin-right: 4px;
            }
        }

        .image_c {
            list-style: none;
            word-break: break-all;
            word-wrap: break-word;
            margin: 0;
            padding: 0;
            border: 0;
            outline: 0;
            vertical-align: baseline;
            background: transparent;
            display: inline-block;
            position: absolute;
            z-index: 0;
            width: 35px;
            height: 22px;
            background-color: rgba(119, 115, 115, 0.8);
            border-bottom-left-radius: 6px;
            right: 0px;
            color: rgb(254, 255, 254);
            text-align: center;
            user-select: none;
            cursor: pointer;
            font-size: 12px;
            line-height: 22px;
        }
    }

    > div {
        height: 111px;
        width: 111px;

        > img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>